import { OwcChip, OwcTypography } from '@one/react';

/**
 * Small status pill built on OwcChip, themed by semantic tone.
 *
 * Defaults to a non-interactive (display-only) chip, matching how statuses are
 * shown in the release history. Pass a `tone` for color, or override colors
 * directly via `background`/`color`.
 *
 * @param {object} props
 * @param {'active'|'deprecated'|'neutral'|'error'|'warning'} [props.tone='neutral']
 * @param {React.ReactNode} props.children
 * @param {string} [props.background]   explicit background (overrides tone)
 * @param {string} [props.color]        explicit text color (overrides tone)
 * @param {object} [props.style]
 */
const TONES = {
  active: {
    background: 'var(--one-color-green-50, #e6f4ea)',
    color: 'var(--one-color-green-800, #1b5e20)',
  },
  deprecated: {
    background: 'var(--one-color-gray-100, #eceff1)',
    color: 'var(--one-color-gray-600, #546e7a)',
  },
  neutral: {
    background: 'var(--one-color-white, #fff)',
    color: 'inherit',
  },
  error: {
    background: 'var(--one-color-cobas-red-50, #fde8e8)',
    color: 'var(--one-color-cobas-red-500, #c00)',
  },
  warning: {
    background: 'var(--one-color-yellow-50, #fff8e1)',
    color: 'var(--one-color-yellow-900, #b45309)',
  },
};

export default function StatusChip({ tone = 'neutral', children, background, color, style }) {
  const toneStyle = TONES[tone] || TONES.neutral;
  return (
    <OwcChip
      disableRipple
      style={{
        background: background || toneStyle.background,
        color: color || toneStyle.color,
        cursor: 'auto',
        ...style,
      }}
    >
      <OwcTypography style={{ fontSize: '12px', fontWeight: 600 }}>{children}</OwcTypography>
    </OwcChip>
  );
}
